import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';

interface ContainerProps {
  size?: number;
  customColors?: Array<string>;
}

export const RoundSpanContainer = styled.div<ContainerProps>`
  position: relative;

  ${(props) =>
    props.size === 0 &&
    css`
      width: 3rem;
      height: 3rem;
    `}
  ${(props) =>
    props.size !== 0 &&
    css`
      width: ${props.size}rem;
      height: ${props.size}rem;
    `}

  span {
    display: block;

    ${(props) =>
      props.size !== 0 &&
      css`
        width: ${props.size}rem;
        height: ${props.size}rem;
      `}

    ${(props) =>
      props.size === 0 &&
      css`
        width: 3rem;
        height: 3rem;
      `}

    /* A prop 'customColors' existia na interface mas nenhum estilo a lia —
       o spinner era sempre laranja, inclusive dentro do botao dourado, onde
       o arco media 1.6:1 e o trilho 1.2:1 (invisivel). A ordem e
       [trilho, arco, rastro1, rastro2, rastro3]. */
    ${(props) => {
      const [track, head, t1, t2, t3] =
        props.customColors && props.customColors.length > 0
          ? props.customColors
          : ['#e9e9e9', '#fc9003', '#fac278', '#ffe2bd', '#ffefdb'];

      return css`
        border: 0.2rem solid ${track};
        border-top: 0.2rem solid ${head};
        border-right: 0.2rem solid ${t1};
        border-bottom: 0.2rem solid ${t2};
        border-left: 0.2rem solid ${t3};
      `;
    }}

    border-radius: 50%;
    box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.4);

    box-sizing: border-box;
    top: 0;
    left: 0;

    position: absolute;
  }
`;

export const DotWaveContainer = styled(motion.div)`
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: space-around;
`;

export const DotWave = styled(motion.span)`
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  background: #878c99;
  border-radius: 50%;
`;
